import { render, staticRenderFns } from "./PaymentSuccessFrame.vue?vue&type=template&id=33a7cc2e&"
import script from "./PaymentSuccessFrame.vue?vue&type=script&lang=js&"
export * from "./PaymentSuccessFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports